// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__34AB0","title":"Widget_title__1LpAz"};